var mqtt = require('mqtt')
var client;

//services
import Helper from './Helper'; var help = Helper
import LocalStorageService from'./LocalStorageService'; var ls = LocalStorageService;

//env
import * as ENV from '../environment/environment';

var device_data; var _mqttSubscription; var default_ops; var _keys;var hotel_id;

device_data = {};
default_ops = {
  retain: false,
  qos: 1
};
_keys = {};



function subscribeMqtt(room_id) {
  _mqttSubscription = client.subscribe('KU/+/' + room_id + '/ping/get')
  client.on('message', (topic, mqttData) => {
    let dev_id = topic.split('/')[1];
    console.log(dev_id, "received msg");
    handlePayload(dev_id, mqttData);

    let evt = new CustomEvent('_mqt', { detail: device_data[dev_id]._mqttMessage });
    window.dispatchEvent(evt);

  });
}

function subscribeHotelMqtt(){
  hotel_id = ls.getUserDetails().hotel_id;
  _mqttSubscription = client.subscribe('FR/' + hotel_id + '/hotel')
  client.on('message', (topic, mqttData) => {
    let x; let body;
    x = mqttData.toString();
    x = JSON.parse(x);
    body = x;
    let evt = new CustomEvent('_mqt', { detail: body });
    window.dispatchEvent(evt);

  });

}

function disconnect() {
  try {
    if (client && client.end) {
      client.end();
    }
    unSubscribeMqtt();
    return;
  }
  catch (err) {
    console.log(err);
    return;
  }
}

function handlePayload(dev_id, data) {
  let x; let body;
  try {
    x = data.toString();
    x = JSON.parse(x);
    body = x.payload && x.meta ? JSON.parse(help.getMqttPayload(x.payload, x.meta, this._keys[dev_id])) : x;
  } catch (err) {
    console.log(err, x);
  }
  if (body) {
    let processed_data;
    if (!device_data[dev_id]) {
      device_data[dev_id] = { _mqttMessage: { data: {}, device_id: dev_id } }
    }
    processed_data = device_data[dev_id]._mqttMessage.data || {};
    if (body.switch) {
      processed_data.switch = body.switch;
    }
    if (body.switch) {
      processed_data.power = body.power;
    }
    if (body.sns) {
      processed_data.sns = body.sns;
    }
    if (body.ev) {
      let evt = new CustomEvent('_mqt', { detail: { ev: body.ev, status: this.device_data[dev_id].status, device_id: dev_id } });
      window.dispatchEvent(evt);
    }
    device_data[dev_id] = {
      status: true,
      lastSeen: Date.now(),
      _mqttMessage: { data: processed_data, device_id: dev_id }
    };
  }
}

function unSubscribeMqtt() {
  if (client && client.conneted) {
    client.unsubscribe();
  }
}

function checkSubscriber() {
  return;
}

function unsafePublish(room_id, device_id, key = 0, ops = 0) {
  let _flag = true;

  if (key) {
    _keys[device_id] = key;
  }
  if (device_data[device_id] && device_data[device_id].lastSeen) {
    let lastSeen = device_data[device_id].lastSeen;
    let _now = Date.now();
    let x = help.findSecsInterval(lastSeen, _now);
    _flag = help.findSecsInterval(lastSeen, _now) > 0 ? true : false;
  }

  if (_flag) {
    let pubTpoic = 'KU/' + device_id + '/' + room_id + '/ping/set';
    console.log(pubTpoic, "from provider");
    let options = ops ? ops : default_ops;
    client.publish(pubTpoic, 'a');
  }
  else {
    let pubTpoic = 'KU/+/' + room_id + '/ping/get';
    let evt = new CustomEvent('_mqt', { detail: device_data[dev_id]._mqttMessage });
    window.dispatchEvent(evt);
  }
}

function connect(username, pass, hotel_id = 0) {
  return new Promise((go, die) => {
    disconnect();
    //_mqttService.disconnect();
    try {
      client = mqtt.connect(`${ENV.MQTT_SECURED ? 'wss' : 'ws'}://${ENV.MQTT_HOST}:${ENV.MQTT_PORT}/${ENV.MQTT_ROUTE}`, { username: username, password: pass })
      if(hotel_id){
        subscribeHotelMqtt();
      } else {
        subscribeMqtt(username);
      }
      client.on('connect', () => {
        go(true)
      })
    }
    catch (err) {
      console.log(err);
      die();
    }
  })
}


function updateSwitch(payload) {
  if (payload.device && device_data[payload.device] && device_data[payload.device]._mqttMessage) {
    try {
      let sw_no = parseInt(payload.switch_no) - 1;
      device_data[payload.device]._mqttMessage.data.switch.relays[sw_no] = payload.switch_state;
    }
    catch (err) {
      console.log(err);
    }
  }
}

function clearLastSeen(device_id) {
  device_data[device_id].lastSeen = "";
}

var MessageService = {
  subscribeMqtt,
  unsafePublish,
  connect,
  disconnect
}
export default MessageService;



// WEBPACK FOOTER //
// ./services/MessageService.js